import { memo, useEffect, useState } from 'react';

import { Form } from 'antd';

import equal from 'fast-deep-equal';

function AppForm({ formRef, data, isEditMode = false, initialValues, onChange, setSubmittable }) {
  const [form] = Form.useForm();
  if (formRef) formRef.current = form;

  const values = Form.useWatch([], form);

  const [initialFormValues, setInitialFormValues] = useState({});

  useEffect(() => {
    const initial = form.getFieldsValue(true);
    setInitialFormValues(initial);
  }, []);

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable?.(true))
      .catch(() => setSubmittable?.(false));
  }, [values]);

  function handleChange() {
    const current = form.getFieldsValue();
    const isSame = equal(current, initialFormValues);

    onChange?.(!isSame);
  }

  return (
    <Form
      form={form}
      labelWrap
      labelCol={{ xs: { span: 24 }, sm: { span: 12 }, md: { span: 6 }, lg: { span: 5 } }}
      labelAlign="left"
      initialValues={initialValues}
      requiredMark={isEditMode}
      onValuesChange={handleChange}>
      {data?.map(d =>
        d.isVisible ? (
          <Form.Item
            key={d.label}
            name={d.name}
            label={d.label}
            colon={false}
            rules={d.rules}
            style={{ marginBottom: '5px' }}>
            {d.value}
          </Form.Item>
        ) : null
      )}
    </Form>
  );
}

export default memo(AppForm);
